var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuMasteradmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-menu-masteradmin",
    transform: "translate(5.668 6.742)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    width: 36,
    height: 36,
    transform: "translate(-5.668 -6.742)",
    fill: "#fff",
    opacity: 0.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_12",
    "data-name": "\\u30D1\\u30B9 12",
    d: "M23.079,19.312,13.82,10.053a6.53,6.53,0,0,0-1.526-7.02A6.726,6.726,0,0,0,4.765,1.71L9.14,6.085,6.088,9.138,1.611,4.763a6.557,6.557,0,0,0,1.323,7.529,6.53,6.53,0,0,0,7.02,1.526l9.259,9.259a.984.984,0,0,0,1.424,0l2.34-2.34A.916.916,0,0,0,23.079,19.312Z",
    transform: "translate(0.168 -0.983)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuMasteradmin);
export default __webpack_public_path__ + "static/media/icon-menu-masteradmin.08f53bf6ad2d45f7331883bc60515251.svg";
export { ForwardRef as ReactComponent };